export default __webpack_public_path__ + "static/media/maj.363113de.mp3";